import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { routerHistory } from 'app/core/router/service';
import UIReducer from './ui/reducer';
import commonReducer from './common/reducer';
import FeaturesMemberRegisterAuthReducer from './features/member/register/auth/reducer';
import FeaturesMemberRegisterGeneralReducer from './features/member/register/general/reducer';
import FeaturesMemberRegisterPermissionReducer from './features/member/register/permission/reducer';
import FeaturesMemberLoginReducer from './features/member/login/reducer';
import FeaturesMemberReauthReducer from './features/member/reauth/reducer';
import FeaturesMemberSettingsEmailReducer from './features/member/settings/email/reducer';
import FeaturesMemberSettingsMobileReducer from './features/member/settings/mobile/reducer';
import FeaturesMemberSettingsPassPhraseReducer from './features/member/settings/passPhrase/reducer';
import FeaturesMemberForgetReducer from './features/member/forget/reducer';
import FeaturesInsureTravelInsuranceReducer from './features/insure/travelInsurance/reducer';
import FeaturesServiceQueryPolicyDetailReducer from './features/service/queryPolicy/detail/reducer';
import FeaturesServiceQueryPolicyPayReducer from './features/service/queryPolicy/pay/reducer';
import FeaturesServiceQueryPolicyModifyReducer from './features/service/queryPolicy/modify/reducer';

const rootReducer = combineReducers({
  router: connectRouter(routerHistory),
  UI: UIReducer,
  common: commonReducer,
  features: combineReducers({
    member: combineReducers({
      register: combineReducers({
        auth: FeaturesMemberRegisterAuthReducer,
        general: FeaturesMemberRegisterGeneralReducer,
        permission: FeaturesMemberRegisterPermissionReducer
      }),
      login: FeaturesMemberLoginReducer,
      reauth: FeaturesMemberReauthReducer,
      settings: combineReducers({
        email: FeaturesMemberSettingsEmailReducer,
        mobile: FeaturesMemberSettingsMobileReducer,
        passPhrase: FeaturesMemberSettingsPassPhraseReducer
      }),
      forget: FeaturesMemberForgetReducer
    }),
    insure: combineReducers({
      travelInsurance: FeaturesInsureTravelInsuranceReducer
    }),
    service: combineReducers({
      queryPolicy: combineReducers({
        detail: FeaturesServiceQueryPolicyDetailReducer,
        pay: FeaturesServiceQueryPolicyPayReducer,
        modify: FeaturesServiceQueryPolicyModifyReducer
      })
    })
  })
});

export default rootReducer;
